import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkle, ArrowDiag } from "@/components/Icons";

const scrollTo = (target) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { duration: 1.5 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};

const links = [
  { label: "Services", target: "#services", testId: "nav-link-services" },
  { label: "Manifeste", target: "#manifesto", testId: "nav-link-manifesto" },
  { label: "Contact", target: "#contact", testId: "nav-link-contact" },
];

export default function Navbar() {
  const [showCta, setShowCta] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const nearBottom = window.innerHeight + window.scrollY > document.documentElement.scrollHeight - 260;
      setShowCta(window.scrollY > window.innerHeight * 0.75 && !nearBottom);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header className="absolute top-0 left-0 w-full z-40 px-5 md:px-10 py-5 flex items-center justify-between" data-testid="navbar">
        <button
          onClick={() => scrollTo("#top")}
          className="flex items-center gap-2 font-display font-extrabold text-flytab-black text-lg md:text-xl tracking-tight uppercase"
          data-testid="nav-logo"
        >
          <Sparkle className="w-5 h-5 md:w-6 md:h-6" strokeWidth={10} />
          FLYTAB
        </button>

        <nav className="hidden md:flex items-center gap-8 font-mono text-sm uppercase tracking-[0.15em] text-flytab-black">
          {links.map((l) => (
            <button
              key={l.target}
              onClick={() => scrollTo(l.target)}
              className="relative group"
              data-testid={l.testId}
            >
              {l.label}
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-flytab-black transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <button
          onClick={() => scrollTo("#contact")}
          className="rounded-full bg-flytab-black text-flytab-green font-mono font-bold text-xs md:text-sm uppercase tracking-wider px-5 md:px-7 py-2.5 md:py-3 transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-[0_6px_0_rgba(0,0,0,0.35)]"
          data-testid="nav-cta-button"
        >
          Démarrer un projet
        </button>
      </header>

      <AnimatePresence>
        {showCta && (
          <motion.button
            initial={{ opacity: 0, y: 24, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.9 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            onClick={() => scrollTo("#contact")}
            className="fixed bottom-5 right-4 md:bottom-6 md:right-6 z-50 rounded-full bg-flytab-green text-flytab-black font-display font-bold text-xs md:text-sm uppercase px-5 md:px-7 py-3 md:py-4 shadow-[0_8px_0_rgba(0,0,0,0.55)] hover:-translate-y-1 transition-transform inline-flex items-center gap-2"
            data-testid="floating-cta-button"
          >
            <span className="sm:hidden">Démarrer</span>
            <span className="hidden sm:inline">Démarrer un projet</span>
            <ArrowDiag className="w-3.5 h-3.5" />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
